import React, {useState, useEffect} from 'react';
import {
  FormControl,
  FormHelperText,
  Input,
  TextareaAutosize,
  Modal,
  Select,
  InputLabel,
  MenuItem
} from '@mui/material';
import CloseButton from '../../buttons/closeButton'
import GreenSubmitButton from '../../buttons/greenSubmitButton';
import RoundedButton from '../../buttons/roundedButton'
import HomeIcon from '@mui/icons-material/Home';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { inject, observer } from "mobx-react";
import Utils from '../../Utils';
import AddressAutocomplete from '../../components/address/AddressAutocomplete';
import AddressPinPicker from '../../components/address/AddressPinPicker';
import { DEFAULT_EMAIL } from '../../assets/globalConstants';
import "./AddOrEditAddressModal.css";
import Box from '@mui/material/Box';

// Translations
import _useTranslate from '../../hooks/_useTranslate';

let streetElement;
let streetNumberElement;
let cityElement;
let postcodeElement;
let apartmentElement;
let addressCommentElement;

const style = {
  position: 'absolute',
   width: {
    xs: '100%',
    sm: '80%', 
    md: 600,  
  },  
  top: {xs: 60, sm: '50%'},
  left: {xs: 0, sm: '50%'},
  transform: {sm: 'translate(-50%, -50%)'}, 
  bgcolor: 'background.paper',
  border: '2px solid var(--border-color)',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

const AddOrEditaddressModal = ({visible, close, itemToEdit, itemIndex, prefill, feathersStore})=> {

  let common = _useTranslate(feathersStore.language, "common");
  let account = _useTranslate(feathersStore.language, "account");  
  
  const [otherSelected, setOther] = useState(false);
  const [homeSelected, setHome] = useState(false);
  const [workSelected, setWork] = useState(false);
  const [header, setHeader] = useState("");
  const [title, setTitle] = useState("Home");
  const [streetNumber, setStreetNumber] = useState("");
  const [street, setStreet] = useState("");
  const [apartment, setApartment] = useState(""); 
  const [addressComment, setAddressComment] = useState(""); 
  const [postcode, setPostcode] = useState(""); 
  const [city, setCity] = useState(1);
  // Exact coordinates, captured only when the customer picks an autocomplete
  // suggestion. Kept 0 (not undefined) to match the platform's existing shape.
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [active, setActive] = useState(false); 
  const [streetError, setStreetError] = useState(false);
  const [streetNumberError, setStreetNumberError] = useState(false);  
  const [loading, setLoading] = useState(false); 

  
  useEffect(() => {    
    setHeader(account.addNewAddress);
    if(Object.keys(itemToEdit).length !== 0 && itemToEdit.constructor === Object){
      setHeader(account.modalHeaderUpdate);
      setTitle(itemToEdit.title);
      switch(itemToEdit.title){
        case "Home" : case "Οικία" : setHome(true); //accept both the canonical and the legacy stored title
        break;
        case "Work" : case "Έργασία" : setWork(true);
        break;
        case "Other" : case "Άλλη Τοποθεσία" : setOther(true);
        break;
      }
      setStreet(itemToEdit.street);
      setStreetNumber(itemToEdit.streetNumber);
      setCity(itemToEdit.city);
      setPostcode(itemToEdit.postcode);
      setApartment(itemToEdit.apartment);
      setAddressComment(itemToEdit.addressComment);
      setActive(itemToEdit.active);
      setLatitude(itemToEdit.latitude || 0);
      setLongitude(itemToEdit.longitude || 0);
    }
  }, [feathersStore.language, account])

  /* Seed the form from a "My location" reverse-geocode. Deliberately NOT done
     through itemToEdit: a non-empty itemToEdit puts saveAddress into EDIT mode,
     which splices at itemIndex and would overwrite an existing address. */
  useEffect(() => {
    if(!prefill || (Object.keys(itemToEdit || {}).length !== 0)) return;
    setStreet(prefill.street || "");
    setStreetNumber(prefill.streetNumber || "");
    if(prefill.postcode) setPostcode(prefill.postcode);
    if(prefill.city) setCity(prefill.city);
    setLatitude(prefill.latitude || 0);
    setLongitude(prefill.longitude || 0);
  }, [prefill])   // eslint-disable-line react-hooks/exhaustive-deps

  const PressOther = ()=> {
    setOther(true);
    setHome(false);
    setWork(false);
    setTitle('Other')
  }

  const PressHome = ()=> {
    setOther(false);
    setHome(true);
    setWork(false);
    setTitle('Home')
  }

  const PressWork = ()=> {
    setOther(false);
    setHome(false);
    setWork(true);
    setTitle('Work');
  }

  const clearCoordinates = () => { setLatitude(0); setLongitude(0); };

  // Free typing in the street field invalidates any previously picked pin.
  const onStreetInput = (text) => {
    setStreet(text);
    streetValidation(text);
    clearCoordinates();
  };

  // The customer picked a suggestion: fill every field it resolved, including
  // the tenant city id (pricing and submission are city-id based) and the
  // exact coordinates.
  const onAddressResolved = (resolved) => {
    setStreet(resolved.street || '');
    streetValidation(resolved.street || '');
    if(resolved.streetNumber){ setStreetNumber(resolved.streetNumber); streetNumberValidation(resolved.streetNumber); }
    if(resolved.postcode) setPostcode(resolved.postcode);
    if(resolved.cityId) setCity(resolved.cityId);
    setLatitude(resolved.latitude);
    setLongitude(resolved.longitude);
  };

  const onChangeText = key => (event) => {

    switch(key){
      case "street" : {setStreet(event.target.value); streetValidation(event.target.value);}
      break;
      // A hand-edited street number no longer matches the picked pin (No. 10 vs
      // No. 200 is a different building), so drop the coordinates rather than
      // ship a stale one to the courier.
      case "streetNumber" : {setStreetNumber(event.target.value); streetNumberValidation(event.target.value); clearCoordinates();}
      break;
      case "city" : {setCity(event.target.value);}
      break;
      case "postcode" : setPostcode(event.target.value); 
      break;
      case "apartment" : setApartment(event.target.value);
      break;
      case "addressComment" : setAddressComment(event.target.value);
      break;
    }
  };

  const enterPressed = key => (ev) => {   
    if (ev.key === 'Enter') {
      switch(key){
        case "street" : streetNumberElement.focus();
        break;
        case "streetNumber" : cityElement.focus();
        break;
        case "city" : postcodeElement.focus();
        break;
        case "postcode" : apartmentElement.focus();
        break;
        case "apartment" : addressCommentElement.focus();
        break;
        case "addressComment" : streetElement.focus();
        break;
      }
        
    }
  }

  const streetValidation = val => {
    if (!Utils.validateNonEmpty(val) ) {
      setStreetError(true);
    }else{
     setStreetError(false);
   }
  }

  const streetNumberValidation = val => {
    if (!Utils.validateNonEmpty(val) ) {      
      setStreetNumberError(true);
    }else{
     setStreetNumberError(false);
   }
  }

  const saveAddress = async () => {
    // Every visitor is signed in as the ONE shared defaultUser, so this would write a
    // stranger's home address onto the document every other visitor reads back. Same
    // guard as profileSettings/changePassword.
    if(feathersStore.user?.email === DEFAULT_EMAIL){
      alert(account.registerToEdit);
      return;
    }
    setLoading(true);
    let clonedAddresses=[]
    if(feathersStore.user?.addresses?.length > 0)clonedAddresses = [...feathersStore.user?.addresses];         
    // NOTE: this literal ENUMERATES its keys, so anything not listed here is
    // silently dropped on the next edit-save — latitude/longitude must live in
    // the literal itself, not be assigned elsewhere.
    const data = { title, city, street,  streetNumber, postcode, apartment, addressComment, active, latitude, longitude};
    if(Object.keys(itemToEdit).length !== 0 && itemToEdit.constructor === Object){
      Object.assign(data, {active: itemToEdit.active})           
      clonedAddresses.splice(itemIndex, 1, data);
    }else {
      clonedAddresses.forEach(i => Object.assign(i, {active: false}))
      Object.assign(data, {active: true})
      clonedAddresses.push(data);     
    }      
    try{
      const user = await feathersStore.patchAddresses( feathersStore.user._id, [...clonedAddresses]);
      feathersStore.setUser(user);
      setLoading(false);   
      alert(common.updateSuccess);
    }catch (error){
      setLoading(false);   
      alert(common.updateError + `:  ${error.message}`)
    }
  };

return(
  <section>    
    <Modal     
      open={visible}
      onClose={close}
      aria-labelledby="address-edit-modal"
      aria-describedby="modal-for-editing-an-address"
    >
    <Box sx={style}>
      <div className="add-address-container">
        <div className="address-modal-header">
          <div className="edit-address-title">
            {header}
          </div>
          <div className="edit-address-close-button">
            <CloseButton onClick={close} aria-labelledby='Close'/> 
          </div>          
        </div>      
        <div className="addNewAddressButtonsContainer">
          <div className="typeAddressButton">
            <RoundedButton
            aria-label='other'
            color={otherSelected? 'green' : '#ebebeb'}
            icon={<ApartmentIcon style={{color: otherSelected? '#fff' : 'gray'}}/>}
            onClick={PressOther}
            />
            <a style={{color: 'var(--secondaryText)', fontSize: 12, marginTop: 5}}>{account.otherLocation}</a>
          </div>
          <div className="typeAddressButton">
            <RoundedButton
            aria-labelledby='Home'
            color={homeSelected? 'green' : '#ebebeb'}
            icon={<HomeIcon style={{color: homeSelected? '#fff' : 'gray'}}/>}
            onClick={PressHome}
            />
            <a style={{color: 'var(--secondaryText)', fontSize: 12, marginTop: 5}}>{account.home}</a>
          </div>
          <div className="typeAddressButton">
            <RoundedButton
            aria-labelledby='Word'
            color={workSelected? 'green' : '#ebebeb'}
            icon={<BusinessCenterIcon style={{color: workSelected? '#fff' : 'gray'}}/>}
            onClick={PressWork}
            />
            <a style={{color: 'var(--secondaryText)', fontSize: 12, marginTop: 5}}>{account.work}</a>
          </div>
        </div>
        <a style={{color: 'var(--secondaryText)'}}>{account.helperText}</a>
        <FormControl style={{width: '80%'}}>
          {/* Google-Places street field. Falls back to a plain input (today's
              behaviour, no Google call) when the tenant has no GOOGLE_MAPS_KEY. */}
          <AddressAutocomplete
            value={street}
            error={streetError}
            helperText={streetError ? common.streetError : ''}
            inputRef={r => {
              streetElement = r;
            }}
            aria-label='street'
            onInputChange={onStreetInput}
            onResolved={onAddressResolved}
            onKeyPress={enterPressed("street")}
            placeholder={common.street + "*"}
            variant="standard"
          />
        </FormControl>
        <FormControl style={{width: '80%'}}> 
          <Input
            value={streetNumber}     
            error={streetNumberError}
            inputRef={r => {
              streetNumberElement = r;
            }}
            aria-label='street number'
            onChange={onChangeText("streetNumber")}              
            onKeyPress={enterPressed("streetNumber")}                
            placeholder={common.streetNumber + "*"}
          />
          {streetNumberError && <FormHelperText id="component-error-text" >{common.streetNumberError}</FormHelperText>}
        </FormControl>        
        <FormControl style={{width: '80%'}}> 
          <InputLabel id="demo-simple-select-label">{common.city + "*"}</InputLabel>
          <Select          
            id="city-address-modal-select"
            inputRef={r => {
              cityElement = r;
            }}
            value={city}
            label={common.city + "*"}
            onChange={onChangeText("city")}  
            onKeyPress={enterPressed("city")}  
          >
            {feathersStore?.settings?.citys
              .filter(city => city.enabled)
              .map(i => 
              <MenuItem key={+i.id} value={+i.id}> {feathersStore._translate(i.name , i.nameEnglish)}</MenuItem>
            )}      
          </Select>         
        </FormControl>
        <FormControl style={{width: '80%'}}> 
          <Input
            value={postcode}         
            inputRef={r => {
              postcodeElement = r;
            }}
            aria-label='postcode'
            onChange={onChangeText("postcode")}              
            onKeyPress={enterPressed("postcode")}                
            placeholder={common.postcode + "*"}
          />       
        </FormControl>
        <FormControl style={{width: '80%'}}> 
          <Input
            value={apartment}          
            inputRef={r => {
              apartmentElement = r;
            }}
            aria-label='apartment'
            onChange={onChangeText("apartment")}              
            onKeyPress={enterPressed("apartment")}                
            placeholder={common.apartment}
          />        
        </FormControl> 
        <FormControl style={{width: '80%'}}> 
          <TextareaAutosize          
            minRows={3}
            maxRows={4}
            value={addressComment}          
            ref={r => {
              addressCommentElement = r;
            }}
            onChange={onChangeText("addressComment")}              
            onKeyPress={enterPressed("addressComment")}                
            placeholder={account.addressComments}
          />        
        </FormControl>
        {/* Calibration step: nudge the pin to the exact entrance. Renders only
            for a tenant with IS_GEO + its own maps key (it costs tile loads),
            and writes back the same fields the autocomplete does. */}
        <div style={{width: '80%'}}>
          <AddressPinPicker
            latitude={latitude}
            longitude={longitude}
            onConfirm={onAddressResolved}
          />
        </div>
        <GreenSubmitButton
        aria-labelledby='Save'
          title={common.save}
          loading={loading}
          disabled={streetError || streetNumberError} 
          onClick={saveAddress}  
        /> 
      </div>
    </Box>
    </Modal>
  </section>
  )
}

export default inject('feathersStore')(observer(AddOrEditaddressModal));